import { Fragment } from "react";
import { containerClasses } from "../../styles/containers";

const RenderStack = ({ style, classes, children, flex }) => {
    const contClass = containerClasses();
    classes = classes.reduce((cls, c) => cls + " " + contClass[c], "");

    return (
        <div style={{ ...style, ...flex }} className={classes}>
            {children}
        </div>
    );
}

export const Stack = ({ style, classes = [], children, flex }) => (
    <Fragment>
        <RenderStack {...{ style, classes: [...classes, "stack"], children, flex }} />
    </Fragment>
);